export default __webpack_public_path__ + "static/media/ic_comoros.6b85b5c7.svg";